import React from 'react';
import WhatsappCTA from '../components/WhatsappCTA';
import Carousel from '../components/Carousel';
import dummy1 from '../assets/Cangrejos/dummy1.jpg';
import dummy2 from '../assets/Cangrejos/dummy2.jpg';
import dummy3 from '../assets/Cangrejos/dummy3.jpg';
import '../styles/SoldOut.css';

const translations = {
  en: {
    title: "Playa Cangrejos Residencial",
    subtitle: "Your Gateway to Puerto Escondido Living.",
    paragraph1: "Exciting news! Playa Cangrejos is expanding with 33 brand-new lots in our highly anticipated second phase. Following the incredible success of our first phase, where over 40 lots quickly found their forever families, we're thrilled to offer you another chance to own a piece of this stunning coastal haven.",
    paragraph2: "Imagine waking up just 5 minutes from the pristine sands of Playa Palmarito, and only a short 15-minute drive from the vibrant heart of Puerto Escondido. Playa Cangrejos offers the perfect blend of tranquility and convenience.",
    paragraph3: "These ready-to-build lots come fully equipped with essential services: water and electricity are already in place, making your dream home a reality even sooner. Plus, you'll be living in close proximity to the renowned El Origen Beach Club and Vivo Resorts, adding a touch of luxury and community to your coastal lifestyle.",
    paragraph4: "Playa Cangrejos boasts its own private entrance, ensuring exclusivity and peace of mind. Don't miss this opportunity to create your own sanctuary in one of Oaxaca's most sought-after locations. Contact us today to secure your lot and start living the life you've always dreamed of!",
    buttonText: "Book",
    includes: "This Lot Includes:",
    includesp1: "Property Regimen Declaration: 'Bienes Comunales'",
    includesp2: "Water Rights and Usage",
    includesp3: "Electricity Rights and Usage",
    includesp4: "Amenities: No Amenities, but personalized entrance and designated green area space"
  },
  es: {
    title: "Residencial Playa Cangrejos",
    subtitle: "Tu Puerta de Entrada a la Vida en Puerto Escondido.",
    paragraph1: "¡Grandes noticias! Playa Cangrejos se expande con 33 nuevos lotes en nuestra muy anticipada segunda fase. Tras el increíble éxito de nuestra primera fase, donde más de 40 lotes encontraron rápidamente a sus familias definitivas, estamos emocionados de ofrecerte otra oportunidad de poseer un pedazo de este impresionante refugio costero.",
    paragraph2: "Imagina despertar a solo 5 minutos de las prístinas arenas de Playa Palmarito, y a solo 15 minutos en auto del vibrante corazón de Puerto Escondido. Playa Cangrejos ofrece la combinación perfecta de tranquilidad y conveniencia.",
    paragraph3: "Estos lotes listos para construir cuentan con servicios esenciales: agua y electricidad ya instalados, haciendo realidad tu hogar soñado incluso más rápido. Además, vivirás cerca del renombrado El Origen Beach Club y Vivo Resorts, agregando un toque de lujo y comunidad a tu estilo de vida costero.",
    paragraph4: "Playa Cangrejos cuenta con entrada privada, garantizando exclusividad y tranquilidad. No pierdas esta oportunidad de crear tu propio santuario en una de las ubicaciones más codiciadas de Oaxaca. ¡Contáctanos hoy mismo para asegurar tu lote y comenzar a vivir la vida que siempre has soñado!",
    buttonText: "Reservar",
    includes: "Este Lote Incluye:",
    includesp1: "Propiedad: 'Bienes Comunales'",
    includesp2: "Uso de agua",
    includesp3: "Instalaciones para Electricidad CFE",
    includesp4: "Amenindades: No tiene amenidades, pero tiene entrada con caseta y área verde designada"
  }
};

const Cangrejos = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].title}</h1>
        
        <Carousel 
          image1={dummy1} 
          image2={dummy2}
          image3={dummy3}
        />
        
        <h2>{translations[language].subtitle}</h2>
        <p>{translations[language].paragraph1}</p>
        <p>{translations[language].paragraph2}</p>
        <p>{translations[language].paragraph3}</p>
        <p>{translations[language].paragraph4}</p>


        <h2>{translations[language].includes}</h2>
        <div className="callout-box">
        <p>📍 {translations[language].includesp1} </p>
        <p>📍 {translations[language].includesp2}  </p>
        <p>📍 {translations[language].includesp3}  </p>
        <p>📍 {translations[language].includesp4}  </p>
        </div>

        
        <WhatsappCTA language={language}/>
        
      </div>
    </div>
  );
};

export default Cangrejos;